import __ from "web/Layout/Translations";

import getSubscriptionChoiceUrl from "web/utils/page/product/subscription/getSubscriptionChoiceUrl";

import urls from "web/constants/urls";

import type { SubscriptionQuoteConfig } from "web/features/subscriptionQuote/subscriptionQuoteSlice";

import type { SubmenuItem } from "./types";

const buildSubscriptionSubmenuData = (
  subscriptionConfig: SubscriptionQuoteConfig,
  enableNewSubscriptionUI: boolean
): SubmenuItem[] => {
  const items: SubmenuItem[] = [];

  if (enableNewSubscriptionUI) {
    items.push({
      title: __("Wybierz abonamenty"),
      url: getSubscriptionChoiceUrl(
        subscriptionConfig.configuratorWindowOpen,
        subscriptionConfig.configuratorWindowOpenUms
      ),
      id: "choose-subscriptions",
    });
  }

  items.push({
    title: __("Moje abonamenty"),
    url: urls.customerSubscriptions,
    id: "my-subscriptions",
  });

  if (enableNewSubscriptionUI) {
    items.push({
      title: __("Katalog abonamentów"),
      url: "/abonamenty.html",
      id: "subscription-catalog",
    });
  }

  return items;
};

export default buildSubscriptionSubmenuData;
